import React, {useContext, useCallback} from 'react';
import {TrackingContext} from '@homeaway/react-event-tracking';

export default function FeedbackLinks(props) {
    const {trigger} = useContext(TrackingContext);

    const eventReviewClick = useCallback(() => {
        trigger('feedback_option.selected', {
            feedback_option: 'leave_property_review'
        });
    }, [trigger]);

    const eventHelpClick = useCallback(() => {
        trigger('feedback_option.selected', {
            feedback_option: 'help_with_issue'
        });
    }, [trigger]);

    const eventCommentClick = useCallback(
        (event) => {
            trigger('feedback_option.selected', {
                feedback_option: 'leave_site_comment'
            });
            props.siteFeedback.open();
            event.preventDefault();
        },
        [trigger, props]
    );

    return (
        <React.Fragment>
            <div className="panel panel-default">
                <div
                    className="panel-heading FeedbackLinks__review-link"
                    onClick={eventReviewClick}
                    role="presentation"
                >
                    <h3 className="panel-title">
                        <a href={props.l10n.reviewLink} target="_blank">
                            {props.l10n.reviewLinkText}
                            <span className="sr-only">
                                {props.l10n.externalLinkSrText}
                            </span>
                        </a>
                    </h3>
                </div>
            </div>
            <div className="panel panel-default">
                <div
                    className="panel-heading FeedbackLinks__help-link"
                    onClick={eventHelpClick}
                    role="presentation"
                >
                    <h3 className="panel-title">
                        <a href={props.l10n.helpLink} target="_blank">
                            {props.l10n.helpLinkText}
                            <span className="sr-only">
                                {props.l10n.externalLinkSrText}
                            </span>
                        </a>
                    </h3>
                </div>
            </div>
            {!props.disableSiteFeedback && (
                <div className="panel panel-default">
                    <div
                        className="panel-heading FeedbackLinks__site-feedback-link"
                        onClick={eventCommentClick}
                        role="presentation"
                    >
                        <h3 className="panel-title">
                            <a href="#" target="_blank">
                                {props.l10n.supportLinkText}
                                <span className="sr-only">
                                    {props.l10n.externalLinkSrText}
                                </span>
                            </a>
                        </h3>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}
